module.exports = __webpack_public_path__ + "static/fillout-4bd67da0a9da04ee65e9c12aa1e1663e.svg";